import { MultiSelect } from '@mantine/core';
import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import i18n from '@/utils/i18n';

interface FilterSectionProps {
  countries: { value: string; label: string }[];
  containerClasses: { value: string; label: string }[];
  containerTypeGroups: { value: string; label: string }[];
  segments?: { value: string; label: string }[];
  currencies: { value: string; label: string }[];
  countryFilter: string[];
  classFilter: string[];
  groupFilter: string[];
  segmentFilter?: string[];
  currencyFilter: string[];
  searchTerm?: string;
  setCountryFilter: (value: string[]) => void;
  setClassFilter: (value: string[]) => void;
  setGroupFilter: (value: string[]) => void;
  setSegmentFilter?: (value: string[]) => void;
  setCurrencyFilter: (value: string[]) => void;
  setSearchTerm?: (value: string) => void;
}

const ContainerTypeFilter: React.FC<FilterSectionProps> = ({
  countries,
  containerClasses,
  containerTypeGroups,
  segments,
  currencies,
  countryFilter,
  classFilter,
  groupFilter,
  segmentFilter,
  currencyFilter,
  searchTerm,
  setCountryFilter,
  setClassFilter,
  setGroupFilter,
  setSegmentFilter,
  setCurrencyFilter,
  setSearchTerm,
}) => {
  return (
    <div>
      <h3>Filters</h3>
      <FormGroup>
        <Label for="countryFilter">Filter by Country</Label>

        <MultiSelect
          id="countryFilter"
          data={countries}
          searchable
          value={countryFilter}
          onChange={(value) => setCountryFilter(value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="classFilter">Filter by Class</Label>
        <MultiSelect
          id="classFilter"
          data={containerClasses}
          searchable
          value={classFilter}
          onChange={(value) => setClassFilter(value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="groupFilter">Filter by Groups</Label>
        <MultiSelect
          id="groupFilter"
          data={containerTypeGroups}
          searchable
          value={groupFilter}
          onChange={(value) => setGroupFilter(value)}
        />
      </FormGroup>
      {segments && segments.length > 0 && setSegmentFilter && (
        <FormGroup>
          <Label for="segmentFilter">
            Filter by {i18n.t('EditContainerInfo:segment')}
          </Label>
          <MultiSelect
            id="segmentFilter"
            data={segments}
            searchable
            value={segmentFilter || []}
            onChange={(value) => setSegmentFilter(value)}
          />
        </FormGroup>
      )}
      {currencies.length > 0 && (
        <FormGroup>
          <Label for="currencyFilter">Filter by Currency</Label>
          <MultiSelect
            id="currencyFilter"
            data={currencies}
            searchable
            value={currencyFilter}
            onChange={(value) => setCurrencyFilter(value)}
          />
        </FormGroup>
      )}
      {searchTerm != null && setSearchTerm != null && (
        <FormGroup>
          <Label for="find">Search</Label>
          <Input
            type="text"
            placeholder="Id, Name, SKU, Legal Owner, Branding"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          />
        </FormGroup>
      )}
    </div>
  );
};

export default ContainerTypeFilter;
